import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  HttpIntegration,
  HttpIntegrationIo,
  HttpIntegrationSliceState,
} from "./httpIntegration-interface";
import {
  fetchHttpIntegrationsById,
  fetchHttpIntegrationsByApplication,
} from "./httpIntegration-async-calls";

const initialState: HttpIntegrationSliceState = {
  httpIntegrations: [],
  selectedHttpIntegration: null,
  selectedHttpIntegrationIo: [],
  selectedHttpIntegrationInitial: null,
  isFetching: false,
};

const httpIntegrationSlice = createSlice({
  name: "httpIntegrations",
  initialState,
  reducers: {
    setSelectedHttpIntegration: (
      state,
      action: PayloadAction<HttpIntegration>
    ) => {
      state.selectedHttpIntegration = action.payload;
    },
    setSelectedHttpIntegrationIo: (
      state,
      action: PayloadAction<HttpIntegrationIo[]>
    ) => {
      state.selectedHttpIntegrationIo = action.payload;
      console.log(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHttpIntegrationsByApplication.pending, (state) => {
        state.httpIntegrations = [];
        state.isFetching = true;
      })
      .addCase(
        fetchHttpIntegrationsByApplication.fulfilled,
        (state, action) => {
          state.httpIntegrations = action.payload;
          state.isFetching = false;
        }
      )
      .addCase(fetchHttpIntegrationsByApplication.rejected, (state) => {
        state.httpIntegrations = [];
        state.isFetching = false;
      })
      .addCase(fetchHttpIntegrationsById.pending, (state) => {
        state.selectedHttpIntegration = null;
        state.selectedHttpIntegrationInitial = null;
        state.selectedHttpIntegrationIo = [];
        state.isFetching = true;
      })
      .addCase(fetchHttpIntegrationsById.fulfilled, (state, action) => {
        state.selectedHttpIntegration = action.payload;
        state.selectedHttpIntegrationInitial = action.payload;
        state.selectedHttpIntegrationIo = action.payload.intgIo;
        state.isFetching = false;
      })
      .addCase(fetchHttpIntegrationsById.rejected, (state) => {
        state.selectedHttpIntegration = null;
        state.selectedHttpIntegrationInitial = null;
        state.selectedHttpIntegrationIo = [];
        state.isFetching = false;
      });
  },
});

export const { setSelectedHttpIntegration, setSelectedHttpIntegrationIo } =
  httpIntegrationSlice.actions;

export default httpIntegrationSlice.reducer;
